<rl-combined-availability
  [depth]="depth"
  [resource]="resource"
  [item]="item"
  [physicalAvailability]="libraryAvailability$ | async"
  [bookstoresAvailability]="bookstoresAvailability$ | async"
  [digitisationLink]="digitisationLink"
  [onlineResource]="onlineResource"
  (onlineResourceClick)="onlineResourceClick.emit($event)"
>
</rl-combined-availability>
